import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'todayYesterday'
})
export class TodayYesterdayPipe implements PipeTransform {

  transform(inputDate: Date): string {

    const currentDate = new Date();
    const yesterdayDate = new Date(currentDate);
    yesterdayDate.setDate(currentDate.getDate() - 1);

    if (new Date(inputDate).getFullYear() == currentDate.getFullYear() && new Date(inputDate).getMonth() == currentDate.getMonth() && 
    new Date(inputDate).getDate() == currentDate.getDate()){
      return "Today";
    } else if (new Date(inputDate).getFullYear() == yesterdayDate.getFullYear() && new Date(inputDate).getMonth() == yesterdayDate.getMonth() &&
    new Date(inputDate).getDate() == yesterdayDate.getDate()){
      return "Yesterday";
    } else{
      return (new DatePipe("en-US")).transform(new Date(inputDate), 'dd/MM/yyyy');
  }
}

}



  
